// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3cKUu","upload":"Small_upload__2VDue","imageWrap":"Small_imageWrap__m50E5","removeBtn":"Small_removeBtn__2khFG"};